import { Platform, StyleProp, TextStyle } from "react-native";

export const TextShadow: StyleProp<TextStyle> = {
    // shadowOpacity: 1,
    // ...(Platform.OS === 'ios' ? {
    //     shadowColor: 'black',
    //     shadowRadius: 4,
    //     shadowOffset: { width: 0, height: 0 },
    // } : {

    //     textAlign: 'left',
    //     textAlignVertical: 'center',
    //     width: '100%',
    //     height: 'auto',
    //     // padding: 4,
    //     textShadowColor: 'black',
    //     textShadowRadius: 8,
    //     textShadowOffset: { width: 0, height: 0 },
    // })
};

export const DefaultShadow: StyleProp<any> = {
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    ...(Platform.OS === 'ios' ? {
        shadowRadius: 10,
        shadowOpacity: 0.1,
    } : {
        shadowOpacity: 0.1,
        elevation: 6,
        shadowRadius: 10,
    }),
}

export const IconShadow = {
    // shadowColor: 'black',
    // shadowOpacity: 1,
    // ...(Platform.OS === 'ios' ? {
    //     shadowRadius: 2,
    //     shadowOffset: { width: 0, height: 0 },
    // } : {
    //     textShadowColor: 'black',
    //     textShadowRadius: 8,
    //     textShadowOffset: { width: 0, height: 0 },
    // })
}
